import service from "@/store/services/inspection-forms-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  inspectionForm: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, inspectionForm) => {
    state.inspectionForm = inspectionForm;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((inspectionForm) => {
      commit("SET_RESOURCE", inspectionForm);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((inspectionForm) => {
      commit("SET_RESOURCE", inspectionForm);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((inspectionForm) => {
      commit("SET_RESOURCE", inspectionForm);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  duplicate({ commit, dispatch }, params) {
    return service.duplicate(params, this.$axios).then((inspectionForm) => {
      commit("SET_RESOURCE", inspectionForm);
    });
  },

  syncFieldsDryRun({ commit, dispatch }, params) {
    return service.syncFieldsDryRun(params, this.$axios).then((response) => {
      return response;
    });
  },

  syncFieldsRun({ commit, dispatch }, params) {
    return service.syncFieldsRun(params, this.$axios).then((response) => {
      return response;
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  inspectionForm: (state) => state.inspectionForm,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((inspectionForm) => ({
      id: inspectionForm.id,
      name: inspectionForm.name,
    }));
  },
};

const inspectionForms = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionForms;
